module.exports = __webpack_public_path__ + "static/media/deleteIcon.8f656779.svg";